export function DotSeparator(props: {className?: string}) {
  return <span {...props}>&middot;</span>;
}
